import { Component } from '@angular/core';
import { Persona } from './persona';
import { ToastrService } from 'ngx-toastr';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { HttpService } from './services/http.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  Usuario = { user: "test", idUser: 1, idRol: 2 };

  ngOnInit() {
 //  localStorage.setItem('Usuario', JSON.stringify(this.Usuario));
 
  }
}
